import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

import { truncateLines } from '../../../../../utils/common';

const themeStyles = new ThemeStyles();

const textStyles = {
  color: 'black',
  fontSize: ['14px', '14px', '16px'],
  lineHeight: ['22px', '22px', '26px'],
};

themeStyles.addBaseStyles('TableCell')(({ lineCount = 1 }) =>
  css({
    ...truncateLines(lineCount),
    width: '120px !important',
  }),
);

themeStyles.addBaseStyles('FlexWrapper')(
  css({
    display: 'flex',
    gap: '16px',
  }),
);

themeStyles.addBaseStyles('CardContainer')(({ theme }) =>
  css({
    padding: '20px',
    borderBottom: `solid 1px ${theme.colors.grey['1']}`,
    '&:active': {
      bg: theme.colors.grey500,
    },
  }),
);

themeStyles.addBaseStyles('TextWrapper')(
  css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    color: 'black',
    fontSize: ['14px', '14px', '14px'],
    lineHeight: ['22px', '22px', '22px'],
    ...truncateLines(2),
  }),
);

themeStyles.addBaseStyles('Text')(
  css({
    ...textStyles,
    ...truncateLines(3),
    textAlign: ['right', 'right', 'left'],
    width: ['150px', '150px', 'unset'],
    marginLeft: ['auto', 'auto', 'unset'],
  }),
);

themeStyles.addBaseStyles('TruncatedText')(({ lineCount = 1 }) =>
  css({
    ...textStyles,
    ...truncateLines(lineCount),
  }),
);

themeStyles.addBaseStyles('BuyNowCTA')(({ width = '100%' }) =>
  css({
    width,
    // minWidth: 'max-content', // for increased width
    minWidth: '150px',
    height: 'max-content',
  }),
);

themeStyles.addBaseStyles('ContactDealerCTA')(
  css({
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: '400 !important',
    color: 'red',
    fontFamily: 'default',
    textAlign: ['right', 'right', 'left'],
    py: 'xs',
    height: 'fit-content',
    textTransform: 'capitalize',
    marginLeft: 'auto',
    overflow: 'hidden',
    width: ['unset', 'unset', '130px'],
    textOverflow: 'ellipsis',
    display: ['-webkit-box', '-webkit-box', 'block'],
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-break': 'after-white-space',
  }),
);

themeStyles.addBaseStyles('DealerDetailsCardBox')(
  ({ theme }) => ({
    width: '100%',
    maxHeight: 0,
    transition: `all ${theme.transitionDuration.t4} ${theme.transitionTimingFunction.default}`,
    overflow: 'hidden',
  }),
  ({ isOpen }) =>
    isOpen && {
      maxHeight: '500px',
    },
);

themeStyles.addBaseStyles('BadgeWrapper')(
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    gap: '10px',
    marginBottom: '10px',
  }),
);

export default themeStyles;
